import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class PhonePaths {
  static phone = new EnhancedPath('/phone');
}

const phoneRoutesConfig = {
  settings: {
    layout: {
      config: {
        toolbar: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: PhonePaths.phone.path,
      component: lazyWithRetry(
        () =>
          import('app/layouts/DefaultLayout/components/BottomNav/components/MobileTelephonyHub'),
      ),
      exact: true,
      isAllowedWithoutRoles: true,
    },
  ],
};

export default phoneRoutesConfig;
